export function formatPayload(formData: any, indicatorEmail?: string) {
  const payload = {
    celular: {
      digitos: formData.phone,
      formatado: formatPhone(formData.phone)
    },
    cpf: {
      digitos: formData.cpf,
      formatado: formatCpf(formData.cpf)
    },
    interesse: [
      formData.produto,
    ],
    indicador: indicatorEmail ?? "",
    nome: formData.name,
  };
  return payload;
}

export const formatCpf = (value: string) => {
  const digits = value.replace(/\D/g, "").slice(0, 11);

  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;

  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
};

export const formatPhone = (value: string) => {
  const digits = value.replace(/\D/g, "").slice(0, 11);

  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 9) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}-${digits.slice(5, 9)}`;

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
};